/**
 * Sibling to `attachInstances`'s per-row method baking pattern: synthesizes
 * row-scoped method dispatcher closures so a reference to a sibling-in-row
 * block's method targets that row's runtime instance.
 */
export function buildRowScopedMethodDispatchers({
  childBlockId,
  runtimeId,
  methodNames,
  callMethod,
}: {
  childBlockId: string;
  runtimeId: string;
  methodNames: readonly string[];
  callMethod: (params: {
    blockId: string;
    targetBlockId: string;
    methodName: string;
    methodPayload: unknown;
  }) => void;
}): Record<string, (payload: unknown) => void> {
  const dispatchers: Record<string, (payload: unknown) => void> = {};
  for (const methodName of methodNames) {
    dispatchers[methodName] = (payload: unknown) => {
      callMethod({
        blockId: childBlockId,
        targetBlockId: runtimeId,
        methodName,
        methodPayload: payload,
      });
    };
  }
  return dispatchers;
}
